import styled, { css } from 'styled-components';
import { SonntagButton } from '../Buttons/SonntagButtonV2/SonntagButton.js';

const Main = styled.div.withConfig({
    displayName: "styled__Main",
    componentId: "sc-69eb8c1f-0"
})`
    width: 100%;
    user-select: none;
`;
const Info = styled.div.withConfig({
    displayName: "styled__Info",
    componentId: "sc-69eb8c1f-1"
})`
    display: flex;
    justify-content: space-between;

    ${(props)=>css`
        padding: 0 ${props.theme.spacers.M} ${props.theme.spacers.L} ${props.theme.spacers.M};
        color: ${props.theme.colors["Level 4"]};
    `}

    ${(props)=>css(props.theme.typography.SmallCapsHeadline)}
`;
const Content = styled.div.withConfig({
    displayName: "styled__Content",
    componentId: "sc-69eb8c1f-2"
})`
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: auto;
    grid-row-gap: ${(props)=>props.theme.spacers.M};
`;
const Button = styled(SonntagButton).withConfig({
    displayName: "styled__Button",
    componentId: "sc-69eb8c1f-3"
})`
    margin-top: ${(props)=>props.theme.spacers.L};
`;

export { Button, Content, Info, Main };
